/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams,
  GetUserRequestsByExternalIdWatchdocsUserRequestId200,
  GetUserRequestsByExternalIdWatchdocsUserRequestId400,
  GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse,
} from '../entities/GetUserRequestsByExternalIdWatchdocsUserRequestId'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetUserRequestByExternalIDResponseSchema } from './v1/getUserRequestByExternalIDResponseSchema'
import { z } from 'zod'

export const getUserRequestsByExternalIdWatchdocsUserRequestIdPathParamsSchema = z.object({
  watchdocs_user_request_id: z.string().describe('Внешний ID заявки'),
}) as unknown as ToZod<GetUserRequestsByExternalIdWatchdocsUserRequestIdPathParams>

/**
 * @description OK
 */
export const getUserRequestsByExternalIdWatchdocsUserRequestId200Schema = z.lazy(
  () => v1GetUserRequestByExternalIDResponseSchema,
) as unknown as ToZod<GetUserRequestsByExternalIdWatchdocsUserRequestId200>

/**
 * @description Bad Request
 */
export const getUserRequestsByExternalIdWatchdocsUserRequestId400Schema = z.lazy(
  () => errorStructSchema,
) as unknown as ToZod<GetUserRequestsByExternalIdWatchdocsUserRequestId400>

export const getUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponseSchema = z.lazy(
  () => getUserRequestsByExternalIdWatchdocsUserRequestId200Schema,
) as unknown as ToZod<GetUserRequestsByExternalIdWatchdocsUserRequestIdQueryResponse>